import QuestionTreeBox from './src/main.js'

export default QuestionTreeBox



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-tree-box/index.js